import { SET_BASE_DATA } from '../constants'

export const setBaseData = payload => {
  return {
    type: SET_BASE_DATA,
    payload,
  }
}
